module.exports = __webpack_public_path__ + "img/Map 2.85da2f25.svg";